import * as React from 'react'
import { observer } from 'mobx-react'
import { Backdrop } from '../backdrop'
import { modalStore as store } from './modal.store'
import { Icon } from '../icon'
import { clearAllBodyScrollLocks } from 'body-scroll-lock'
import './modal.scss'

@observer
export class Modal extends React.Component {
  baseClass: string = 'modal'
  targetElement: HTMLElement = null

  componentDidMount(): void {
    store.targetElement = document.getElementById('modal')
  }

  componentWillUnmount(): void {
    clearAllBodyScrollLocks()
    store.targetElement = null
  }

  render(): React.ReactNode {
    return (
      <Backdrop
        onClick={store.toggle}
        show={store.show}
        contentCentered
      >
        <div className={`${this.baseClass}${store.fullScreen ? ' modal--full' : ''}`}>
          <button
            className={`${this.baseClass}__close`}
            onClick={store.toggle}
          >
            <Icon icon="cross" />
          </button>
          {store.content}
        </div>
      </Backdrop>
    )
  }
}
